import { goerliTestnetTokens } from '@noahswap/tokens'
import { SerializedFarmConfig } from '../../types'

const priceHelperLps: SerializedFarmConfig[] = []

export default priceHelperLps
